import { Typography } from "@povio/ui";
import { Fragment } from "react";

import ProfileSectionRow from "@/components/home/sections/components/ProfileSectionRow";
import ProfileWorkExperienceItem from "@/components/home/sections/components/ProfileWorkExperienceItem";
import type { ISectionProps } from "@/components/home/sections/ProfileBioSection";
import ProfileSectionCard from "@/components/home/sections/ProfileSectionCard";
import { DatePeriodSegment } from "@/components/ui/DatePeriodSegment";
import { ItemSectionDivider } from "@/components/ui/ItemSectionDivider";
import type { CommonModels } from "@/data/common/common.models";
import { DateUtils } from "@/util/date.utils";
import { ProfileUtils } from "@/util/profile.utils";

interface IProps extends ISectionProps {
  workExperience?: CommonModels.CompanyDto[];
}

const ProfileWorkExperienceSection = ({
  workExperience,
  onEditSectionClicked,
  isPublic = false,
  enableInViewAnimation,
}: IProps) => {
  const filteredWorkExperience = workExperience?.filter((item) => {
    if (!item.name?.trim() && !item.industry?.trim()) {
      return false;
    }
    return true;
  });
  return (
    <ProfileSectionCard
      title="Work Experience"
      isEmpty={!filteredWorkExperience || filteredWorkExperience.length === 0}
      onEditSectionClicked={onEditSectionClicked}
      isPublic={isPublic}
      enableInViewAnimation={enableInViewAnimation}
    >
      <div className="mt-6 flex flex-col gap-6">
        {filteredWorkExperience?.map((item, index) => {
          const filteredPositions = item.positions.filter((position) => {
            const isPeriodEmpty = !position.period?.start_date?.trim() && !position.period?.end_date?.trim();
            if (!position.role_title?.trim() && isPeriodEmpty) {
              return false;
            }
            return true;
          });
          return filteredPositions?.map((firstPosition, firstPositionIndex) => {
            const displayAddress = ProfileUtils.getDisplayAddress(firstPosition?.location);

            return (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={`${index} - ${firstPositionIndex}`}>
                <ProfileSectionRow
                  title={`${firstPosition?.role_title} ${item.name ? `@${item.name}` : ""}`}
                  subTitle={
                    <Typography
                      size="label-4"
                      className="text-text-default-3"
                    >
                      <DatePeriodSegment period={firstPosition?.period} />
                      {firstPosition?.period?.start_date && firstPosition?.period?.end_date && (
                        <>
                          {" "}
                          -{" "}
                          {DateUtils.getMonthsDurationFromRange(
                            firstPosition?.period?.start_date,
                            firstPosition?.period?.end_date,
                          )}
                        </>
                      )}
                    </Typography>
                  }
                  index={index}
                  sectionId="work-experience"
                  hasAdditionalInfo={
                    !!firstPosition?.description || !!firstPosition?.location?.msa_title || !!firstPosition?.description
                  }
                >
                  {displayAddress ? (
                    <ProfileWorkExperienceItem
                      value={displayAddress}
                      segment="Location"
                    />
                  ) : undefined}
                  <ProfileWorkExperienceItem
                    value={firstPosition?.description}
                    segment="Description"
                  />
                </ProfileSectionRow>
                {index !== filteredWorkExperience.length - 1 && <ItemSectionDivider />}
              </Fragment>
            );
          });
        })}
      </div>
    </ProfileSectionCard>
  );
};

export default ProfileWorkExperienceSection;
